import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { IconSeekers } from 'ui-seeker/core'
import { AppTooltip } from 'app/@components'
import './compsetExclusionName.css'

// Hotel name with a small toggle icon before it to exclude / include the hotel in the compset of the analyzer
// tables (Competition / Packages). Only the icon is clickable: the row keeps its drag & drop, the main-hotel pin
// keeps its own click and the name stays plain text (struck-through when excluded).
// Row styling for excluded hotels: add `tr-excluded-hotel` to the row (setRowProps).
export default function CompsetExclusionName({ name, excluded, onToggle, style }) {
    const { t } = useTranslation('common')

    const handleClick = e => {
        e.stopPropagation()
        onToggle()
    }

    const handleKeyDown = e => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            e.stopPropagation()
            onToggle()
        }
    }

    return <span className="compset-exclusion">
        <AppTooltip title={t(excluded ? 'compsetExclusion.include' : 'compsetExclusion.exclude')} placement="right">
            <span
                role="button"
                tabIndex={0}
                aria-pressed={excluded}
                aria-label={t(excluded ? 'compsetExclusion.include' : 'compsetExclusion.exclude')}
                className={`compset-exclusion__toggle ${excluded ? 'compset-exclusion__toggle--excluded' : ''}`}
                onClick={handleClick}
                onKeyDown={handleKeyDown}
            >
                <IconSeekers icon={excluded ? 'eye-slash' : 'eye'} iconType="fontAwesome" />
            </span>
        </AppTooltip>
        <span className={`compset-exclusion__name ${excluded ? 'compset-exclusion__name--excluded' : ''}`} style={style}>
            {name}
        </span>
    </span>
}
